import { render } from "./Partner.vue?vue&type=template&id=3f0149b5&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=ts"
export * from "./Partner.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3f0149b5"

export default script